import React, { useState } from "react";
// import DownArrow from "../../../asset/images/down-arrow.svg";
import Lowarrow from "../../../asset/images/low-arrow.svg";
import UpArrow from "../../../asset/images/up-arrow.svg";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import {
  forToFix,
  numDifferentiationWithoutSymbol,
} from "../../../CommonMethhods/CovertRupees";
import { Constants } from "../../../CommonMethhods/Constants";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function SnapshotTable(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [yesterday, setYesterday] = useState(null);
  const [weekly, setWeekly] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [chartEq, setChartEq] = useState(null);
  const [chartFno, setChartFno] = useState(null);
  const title = props.title.split(" ")[0];
  const firstColumnTitle = title === "Sales" ? "Turnover" : title;

  const getSnapshotTableDetails = async (urlEndpoint) => {
    try {
      const getSnapshotDetails = await axiosInstance.post(
        urlEndpoint,
        {},
      );

      const response = getSnapshotDetails.data.data;

      setYesterday(response.yesterday);
      setWeekly(response.weekly);
      setMonth(response.monthly);
      setYear(response.yearly);
      setChartEq(response.monthly.equity.chgper);
      setChartFno(response.monthly.fno.chgper);

      //  let y= x('hiii')

      // test("demo")
    } catch (error) {
      console.log(error);
    }
  };

  // function test(data){
  //   props.forChart(data)
  // }

  if (props.revenueSnapshotTable === true) {
    props.handleRevenueSnapshotTable(false);
    props.forChart(chartEq, chartFno);

    getSnapshotTableDetails(DASHBOARD_DEFAULT.RevenueSnapshot_URL);
  }

  if (props.aumSnapshotTable === true) {
    props.handleAumSnapshotTable(false);
    props.forChart(chartEq, chartFno);
    getSnapshotTableDetails(DASHBOARD_DEFAULT.AUMSnapshot_URL);
  }

  if (props.salesSnapshotTable === true) {
    props.handleSalesSnapshotTable(false);
    getSnapshotTableDetails(DASHBOARD_DEFAULT.SalesSnapshot_URL);
  }

  const rowLabels = [
    "Equity",
    // "PMS",
    "F&O",
    "Total",
  ];

  // to handle empty data and generate empt div
  const handleifTableEmpty = (flag) => {
    const tempArray = [
      [0, 0, 0],
      // [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0],
    ];

    return tempArray.map((column, index) => {
      return (
        <tr key={index}>
          {flag === true ? (
            <th className="text-left header-width">{rowLabels[index]}</th>
          ) : (
            <th className="text-left header-width"></th>
          )}
          {column.map((v, index) => {
            return (
              <td key={index} className="snapshot-table-column">
                {"0"}
              </td>
            );
          })}
        </tr>
      );
    });
  };

  //handle data
  const generateSnapshotTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      const columnValues = rows[column];

      rows[column].revenue =
        numDifferentiationWithoutSymbol(rows[column].revenue) || 0;
      rows[column].chg = numDifferentiationWithoutSymbol(rows[column].chg) || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;

      return (
        <tr key={index} className="snapshot-table-row">
          {flag === true ? (
            <th className="text-left header-width"> {rowLabels[index]}</th>
          ) : (
            <th className="text-left header-width"></th>
          )}
          {Object.keys(columnValues).map((value, index) => {
            return (
              <td key={index} className="snapshot-table-column">
                {index === 0 ? (
                  <img
                    src={columnValues[value] < 0 ? Lowarrow : UpArrow}
                    alt=""
                  />
                ) : (
                  ""
                )}
                {columnValues[value] === undefined || null
                  ? "0"
                  : columnValues[value]}
              </td>
            );
          })}
        </tr>
      );
    });
  };
  return (
    <div className="snapshot-detail-block revenue-detail">
      <div className="card-title mb-0">
        <h2>
          {props.title}
          <span>{Constants.Amount_In_Lacs}</span>
        </h2>
        {/* <div className="card-right">
          <div className="dropdown-filter">
            <div className="list-head">
              <p>
                All Products <img src={DownArrow} alt="" />
              </p>
            </div>
            <div className="list-item">
              <ul>
                <li>Product 1</li>
                <li>Product 2</li>
                <li>Product 3</li>
                <li>Product 4</li>
              </ul>
            </div>
          </div>
        </div> */}
      </div>

      <div className="snapshot-table scroll-table">
        <table className="table tabel-level1">
          <tr>
            <td>
              <table className="table table-level2">
                <thead>
                  <tr>
                    <th className="header-width"></th>
                    <th colSpan="3" scope="col" className="col-width-tab">
                      {Constants.Yesterday}
                      <br />
                      <span>{Constants.Immediate_Previous_Date}</span>
                    </th>
                  </tr>
                  <tr>
                    <th className="header-width"></th>
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {yesterday === null || undefined
                    ? handleifTableEmpty(true)
                    : generateSnapshotTableData(yesterday, true)}
                </tbody>
              </table>
            </td>
            <td>
              <table className="table table-level3">
                <thead>
                  <tr>
                    <th className="header-width"></th>
                    <th colSpan="3" scope="col" className="col-width-tab">
                      {Constants.Current_Week}
                      <br />
                      <span>{Constants.Compare_Week}</span>
                    </th>
                  </tr>
                  <tr>
                    <th className="header-width"></th>
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {weekly === null || undefined
                    ? handleifTableEmpty()
                    : generateSnapshotTableData(weekly)}
                </tbody>
              </table>
            </td>
            <td>
              <table className="table table-level4">
                <thead>
                  <tr>
                    <th className="header-width"></th>
                    <th colSpan="3" scope="col" className="col-width-tab">
                      {Constants.Current_Month}
                      <br />
                      <span>{Constants.Compare_Month}</span>
                    </th>
                  </tr>
                  <tr>
                    <th className="header-width"></th>
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {month === null || undefined
                    ? handleifTableEmpty()
                    : generateSnapshotTableData(month)}
                </tbody>
              </table>
            </td>
            <td>
              <table className="table table-level5">
                <thead>
                  <tr>
                    <th className="header-width"></th>
                    <th colSpan="3" scope="col" className="col-width-tab">
                      {Constants.Current_Year}
                      <br />
                      <span>{Constants.Compare_Year}</span>
                    </th>
                  </tr>
                  <tr>
                    <th className="header-width"></th>
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {year === null || undefined
                    ? handleifTableEmpty()
                    : generateSnapshotTableData(year)}
                </tbody>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
}

export default SnapshotTable;
